// extracted by mini-css-extract-plugin
export var post = "post-module--post--3LtSx";